var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"text-uppercase font-weight-medium glass-effect-chip",attrs:{"color":_vm.chipColor,"text-color":"white","small":"","label":""}},[_vm._v(" "+_vm._s(_vm.category)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }